// const nav = document.querySelector('#main-nav');
// const marker = document.querySelector('#nav-marker');
// let lastScroll = 0;

// window.addEventListener('scroll', () => {
//   const currentScroll = window.pageYOffset;
//   const markerPosition = marker.offsetTop;

//   // 1. Logic to stick the nav
//   if (currentScroll > markerPosition) {
//     nav.classList.add('is-stuck');
//   } else {
//     nav.classList.remove('is-stuck');
//     nav.classList.remove('nav-hidden'); // Always show when at the top
//   }

//   // 2. Logic to hide/show based on scroll direction
//   if (currentScroll > lastScroll && currentScroll > markerPosition + 50) {
//     // Scrolling Down - Show the nav
//     nav.classList.remove('nav-hidden');
//   } else if (currentScroll < lastScroll && currentScroll > markerPosition) {
//     // Scrolling Up - Hide the nav
//     nav.classList.add('nav-hidden');
//   }

//   lastScroll = currentScroll;
// });


const nav = document.querySelector('#main-nav');
const marker = document.querySelector('#nav-marker');
let lastScroll = 0;

window.addEventListener('scroll', () => {
  // Only run logic if screen is wider than 875px
  if (window.innerWidth > 875) {
    const currentScroll = window.pageYOffset;
    const markerPosition = marker.offsetTop;

    // Sticky logic
    if (currentScroll > markerPosition) {
      nav.classList.add('is-stuck');
    } else {
      nav.classList.remove('is-stuck');
      nav.classList.remove('nav-hidden');
    }

    // Hide/Show logic
    if (currentScroll > lastScroll && currentScroll > markerPosition + 50) {
      nav.classList.remove('nav-hidden');
    } else if (currentScroll < lastScroll && currentScroll > markerPosition) {
      nav.classList.add('nav-hidden');
    }
    
    lastScroll = currentScroll;
  } else {
    // Reset classes if user resizes window down to mobile
    nav.classList.remove('is-stuck', 'nav-hidden');
  }
});

